<template>
  <default-item class="menu--item-oceano_default" :item="item" :show-bin="showBin" :pricing-types="pricingTypes"
                :is-grouped-by-price="isGroupedByPrice" :tag-location="tagLocation"></default-item>
</template>

<script lang="ts">
/**
 * Custom component for Oceano menu items.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.1
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-08-29 (1.0.0) (jhoward)
 *      - <WVSteakHouseFoodItem> copied to <oceano-default-item>.
 *
 *    2025-04-08 (1.0.1) (jhoward)
 *      - Remove "visual_" prefix from class names in <OceanoDefaultItem>.
 *      - Add "tagLocation:" prop in <OceanoDefaultItem>.
 */

import {defineComponent, PropType} from "vue";
import {MENU_ITEM_TAG_LOCATIONS, MenuItem} from "../defs";
import DefaultItem from "./defaultItem.vue";

export default defineComponent({
  name: 'OceanoDefaultItem',
  components: {
    DefaultItem
  },
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    },
    showBin: {
      type: Boolean,
      default: false
    },
    pricingTypes: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    isGroupedByPrice: {
      type: Boolean,
      default: false
    },
    tagLocation: {
      type: String as PropType<MENU_ITEM_TAG_LOCATIONS>,
      default: ''
    },
  },
})
</script>

<style scoped>

</style>